import React from 'react'

const TableFormat = () => {
  return (
    <div className='tableFormat'>
    <table>
        <thead>
            <tr>
                <th>Factor</th>
                <th>Fresh Embryo Transfer</th>
                <th>Frozen Embryo Transfer</th>
            </tr>
        </thead>
        <tbody>
            
            {tableData.map((data, index) => (
                <tr key={index}>
                    <td>{data.one}</td>
                    <td>{data.two}</td>
                    <td>{data.three}</td>
                </tr>
            ))}
        </tbody>
    </table>
    
    </div>
  )
}

export default TableFormat

const tableData = [
    {
        one: "Timing",
        two: "Immediate (same cycle)",
        three: "Delayed (future cycle)"
    },
    {
        one: "Cost",
        two: "Generally lower",
        three: "Higher due to freezing/storage"
    },
    {
        one: "Uterine Environment",
        two: "May be affected by stimulation",
        three: "More natural/hormonally controlled"
    },
    {
        one: "OHSS Risk",
        two: "Higher",
        three: "Lower"
    },
    {
        one: "Success Rates",
        two: "Slightly lower in some studies",
        three: "Higher in select cases"
    },
    {
        one: "Convenience",
        two: "Faster results",
        three: "Greater flexibility in planning"
    },
    
]